(ns common.schema.entities.lp-portal.lp-report
  (:require
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def hardcoded-fund-templates
  {:lp-report-template/materials-only                           "-- Materials only --"
   :lp-report-template.capman/private-equity-fund-boxi          "PE BOXI"
   :lp-report-template.capman/private-equity-fund-buyout-x      "Private Equity"
   :lp-report-template.capman/private-equity-fund-buyout-x-v2   "Private Equity v2"
   :lp-report-template.capman/credit-fund                       "Credit"
   :lp-report-template.capman/credit-fund-v2                    "Credit v2"
   :lp-report-template.capman/credit-fund-v2-capman             "Credit v2 Capman logo"
   :lp-report-template.capman/credit-fund-v3                    "Credit v3"
   :lp-report-template.capman/infra-fund                        "Infra"
   :lp-report-template.capman/real-estate-fund-nre              "RE Value-add"
   :lp-report-template.capman/real-estate-fund-hotels           "RE Hotels"
   :lp-report-template.capman/real-estate-fund-hotels-v2        "RE Hotels v2"
   :lp-report-template.capman/real-estate-fund-hotels-v3        "RE Hotels v3"
   :lp-report-template.capman/real-estate-fund-koke             "RE Koke"
   :lp-report-template.capman/real-estate-fund-resi             "RE Resi"
   :lp-report-template.capman/real-estate-fund-resi-v2          "RE Resi v2"
   :lp-report-template.capman/real-estate-fund-stockholm-living "Stockholm living"
   :lp-report-template.capman/feeder-fund                       "Feeder fund"
   :lp-report-template.capman/endowment-fund                    "Endowment fund"
   :lp-report-template.capman/dasos-natural-capital             "Natural Capital"
   :lp-report-template.capman/dasos-natural-capital-FIN         "Natural Capital (Finnish)"
   :lp-report-template.invest-europe/fund                       "Invest Europe"
   :lp-report-template.voima/fund                               "Invest Europe - Private Equity fund template"
   :lp-report-template.sparkmind/fund                           "Sparkmind fund template"
   :lp-report-template.innovestor/fund                          "Innovestor fund template"
   :lp-report-template.innovestor/feeder-fund                   "Innovestor feeder fund template"
   :lp-report-template.innovestor/technology-fund               "Innovestor technology fund template"
   :lp-report-template.innovestor/technology-fund-v2            "Innovestor technology fund template (Bulk import)"
   :lp-report-template.lifeline/fund                            "Lifeline Ventures Fund IV Ky template"
   :lp-report-template.lifeline/fund-v                          "Lifeline Ventures Fund V Ky template"
   :lp-report-template.lifeline/fund-vi                         "Lifeline Ventures Fund VI Ky template"})

(defn feeder-template?
  [k]
  (some #{k}
        [:lp-report-template/materials-only
         :lp-report-template.capman/feeder-fund
         :lp-report-template.capman/endowment-fund
         :lp-report-template.innovestor/feeder-fund]))

(def fund-template-options
  (->> hardcoded-fund-templates
       (map (fn [[k l]]
              {:key   k
               :label l}))
       (doall)))

(def report-status-options
  [{:key     :lp-report.step/initialization
    :icon-id :cog
    :label   "Initialization"}
   {:key     :lp-report.step/data-gathering
    :icon-id :server
    :label   "Data gathering"}
   {:key     :lp-report.step/review
    :icon-id :file-invoice
    :label   "Review"}
   {:key     :lp-report.step/pending-approval
    :icon-id :hourglass-end
    :label   "Pending approval"}
   {:key     :lp-report.step/approved
    :icon-id :cog
    :label   "Approved"}
   {:key     :lp-report.step/publishing-queue
    :icon-id :file-check
    :label   "Publishing queue"}
   {:key     :lp-report.step/published
    :icon-id :file-certificate
    :label   "Published"}
   {:key     :lp-report.step/archived
    :icon-id :file-check
    :label   "Archived"}])

(def publishing-statuses
  {:lp-report.publishing-status/wip              "WIP"
   :lp-report.publishing-status/pending-approval "Waiting for approval"
   :lp-report.publishing-status/approved         "Approved"})

(def publishing-status-options
  (->> publishing-statuses
       (map (fn [[k l]]
              {:key   k
               :label l}))
       (doall)))

(defn entity-ids
  [entities-or-ids]
  (->> entities-or-ids
       (mapv (fn [eid]
               (or (:db/id eid) eid)))))

(defn can-configure?
  [report admin-or-owner?]
  (and admin-or-owner?
       (not (some #{(:lp-report/step report)}
                  [:lp-report.step/archived]))))

(defn can-process?
  [_report admin-or-owner?]
  admin-or-owner?)

#_(defn can-view?
    [{:keys [fund-report account-id admin-or-owner?]}]
    (or admin-or-owner?
        (some #{account-id}
              (remove nil?
                      (entity-ids (concat (:lp-report/text-contributors fund-report)
                                          (:lp-report/data-contributors fund-report)
                                          (:lp-report/followers fund-report)
                                          [(:lp-report/text-approver fund-report)
                                           (:lp-report/data-approver fund-report)
                                           (:lp-report/final-approver fund-report)]))))))

(defn can-edit-text?
  [{:keys [fund-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (remove nil?
                    (entity-ids (concat (:lp-report/text-contributors fund-report)
                                        [(:lp-report/text-approver fund-report)
                                         (:lp-report/final-approver fund-report)]))))))

(defn can-edit-footers?
  [{:keys [fund-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (remove nil?
                    (entity-ids (concat (:lp-report/text-contributors fund-report)
                                        (:lp-report/data-contributors fund-report)
                                        [(:lp-report/text-approver fund-report)
                                         (:lp-report/data-approver fund-report)
                                         (:lp-report/final-approver fund-report)]))))))

(defn can-update-data?
  [{:keys [fund-report master-report account-id admin?]}]
  (or admin?
      (some #{account-id}
            (remove nil?
                    (entity-ids (concat (:lp-report/process-owners fund-report)
                                        (:lp-report/process-owners master-report)
                                        (:lp-report/data-contributors fund-report)
                                        [(:lp-report/data-approver fund-report)
                                         (:lp-report/final-approver fund-report)]))))))

(defn can-approve-text?
  [{:keys [fund-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (remove nil?
                    (entity-ids [(:lp-report/text-approver fund-report)
                                 (:lp-report/final-approver fund-report)])))))

(defn can-approve-data?
  [{:keys [fund-report master-report account-id admin? admin-or-owner?]}]
  (or admin?
      admin-or-owner?
      (some #{account-id}
            (remove nil?
                    (entity-ids (concat (:lp-report/process-owners fund-report)
                                        (:lp-report/process-owners master-report)
                                        [(:lp-report/data-approver fund-report)
                                         (:lp-report/final-approver fund-report)]))))))

(defn can-do-final-approval?
  [{:keys [fund-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (remove nil?
                    (entity-ids [(:lp-report/final-approver fund-report)])))))

(def schema
  (concat
   (su/text-edn-field :lp-report/data
                      "Report data"
                      (system-controlled {:authorization             su/access-system-lpg
                                          :default-field-visibility :in-use}))
   (su/single-ref-field :lp-report/final-approver
                        "Final approver"
                        [:entity.type/account]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
   (su/single-ref-field :lp-report/fund
                        "Fund"
                        [:entity.type/fund]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
   (su/single-ref-field :lp-report/main-report
                        "Main report"
                        [:entity.type/lp-report]
                        (system-controlled {:authorization             su/access-system-lpg
                                            :default-field-visibility :in-use}))
   (su/multi-ref-field :lp-report/holdings
                       "Report holdings"
                       [:entity.type/lp-report-holding]
                       {:authorization su/access-user-lpg
                        :default-field-visibility :in-use})
   (su/multi-ref-field :lp-report/investors
                       "Investor commitments"
                       [:entity.type/lp-report-investor-commitment]
                       (system-controlled {:authorization             su/access-system-lpg
                                           :default-field-visibility :in-use}))
   (su/multi-ref-field :lp-report/process-owners
                       "Process owners"
                       [:entity.type/account]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
   (su/multi-ref-field :lp-report/text-contributors
                       "Text contributors"                                                          ;; Fund contributor, Data contributor
                       [:entity.type/account]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
   (su/multi-ref-field :lp-report/data-contributors
                       "Data contributors"                                                          ;; Fund contributor, Data contributor
                       [:entity.type/account]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
   (su/single-ref-field :lp-report/data-approver
                        "Data approver"                                                             ;; Fund contributor, Data contributor
                        [:entity.type/account]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
   (su/single-ref-field :lp-report/text-approver
                        "Text approver"                                                             ;; Fund contributor, Data contributor
                        [:entity.type/account]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
   (su/multi-ref-field :lp-report/followers
                       "Read access"
                       [:entity.type/account]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
   (su/keyword-field :lp-report/step
                     "Report step"
                     report-status-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})
   (su/keyword-field :lp-report/text-status
                     "Text status"
                     publishing-status-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})
   (su/keyword-field :lp-report/data-status
                     "Data status"
                     publishing-status-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})
   (su/keyword-field :lp-report/template-type
                     "Template type"
                     fund-template-options
                     {:authorization su/access-user-lpg
                      :default-field-visibility :in-use})
   (su/text-simple-field :lp-report/title "Title" {:authorization su/access-user-user
                                                   :default-field-visibility :in-use})
   (su/single-ref-field :lp-report/report-data-file
                        "Fund report data file"
                        [:entity.type/attachment]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
   (su/text-edn-field :lp-report/report-data-status
                      "Fund report data status"
                      (system-controlled {:authorization             su/access-system-user
                                          :default-field-visibility :in-use}))
   (su/text-edn-field :lp-report/editable-data
                      "Editable dta"
                      (system-controlled {:authorization             su/access-system-lpg
                                          :default-field-visibility :in-use}))
   (su/text-edn-field :lp-report/export-permissions
                      "Export permissions"
                      ;; access-system-user (read :role/user) keeps this out of
                      ;; LP-portal guest responses so we never leak other
                      ;; investors' identifiers/overrides; the editor (user) reads it.
                      {:authorization su/access-system-user
                       :default-field-visibility :in-use})
   (su/text-edn-field :lp-report/editable-report-images
                      "Editable report images"
                      (system-controlled {:authorization             su/access-system-lpg
                                          :default-field-visibility :in-use}))
   (su/multi-ref-field :lp-report/materials
                       "Materials"
                       [:entity.type/attachment]
                       (system-controlled {:authorization             su/access-system-lpg
                                           :default-field-visibility :in-use}))
   (su/multi-ref-field :lp-report/images
                       "Images"
                       [:entity.type/attachment]
                       (system-controlled {:authorization             su/access-system-lpg
                                           :default-field-visibility :in-use}))
   (su/multi-ref-field :lp-report/burned-pdfs
                       "PDFs"
                       [:entity.type/attachment]
                       (system-controlled {:authorization             su/access-system-lpg
                                           :default-field-visibility :in-use}))
   (su/datetime-field :lp-report/published-on "Published on" {:authorization su/access-user-user
                                                              :default-field-visibility :in-use})
   (su/datetime-field :lp-report/archived-on "Archived on" {:authorization su/access-user-user
                                                            :default-field-visibility :in-use})
   (su/image-field :lp-report/pdf-front-page-image
                   "PDF cover image"
                   {:authorization su/access-user-user
                    :default-field-visibility :in-use})))
